type SlateNode = { text?: string; children?: SlateNode[] };

const nodeText = (node: SlateNode): string =>
  typeof node?.text === 'string' ? node.text : (node?.children ?? []).map(nodeText).join(' ');

/**
 * One line of what the agent has typed but not sent, for the folded comment box.
 * Falls back to the names of attached files when there is no text, so a folded box
 * holding only an attachment still says it is holding something. Empty means no draft.
 */
export const draftPreviewText = (body: SlateNode[] | null | undefined, fileNames: string[] = []): string => {
  const text = (body ?? []).map(nodeText).join(' ').replace(/\s+/g, ' ').trim();
  return text || fileNames.join(', ');
};
